import Files from "../fmanlibs/Files";
import FManApi from "../fmanlibs/FManApi";
import Button from "../gui/Button/Button";
import AccountIcon from "../gui/Icons/AccountIcon";
import LogoutIcon from "../gui/Icons/LogoutIcon";
import { useAuth } from "../gui/Login/AuthProvider";
import { useLogin } from "../gui/Login/LoginProvider";
import MenuButton from "../gui/Menu/MenuButton";
import { usePath } from "../libs/path/PathProvider";

function LoginMenu(){
    const {setPath} = usePath()
    const onLogout = () => {
        FManApi.i.logout()
        Files.i.expireAll()
        setPath("/")
    }
    const options = [{id:"logout",text:"Logout",icon:<LogoutIcon/>,onClick:onLogout}]
    return <MenuButton menuProps={{options}} size="medium"><AccountIcon/>{FManApi.i.name}</MenuButton>
}
export default function Header(){
    const {isLoggedIn} = useAuth()
    const {login} = useLogin()
    const loginButton = isLoggedIn ? LoginMenu() : <Button variant="contained" size="medium" onClick={_ => login()}>Login</Button>
    return <header className="flex middle gap-8">
        <div className="logo"/>
        <b>File Manager</b>
        <div className="flex1"/>
        {loginButton}
    </header>
}